// Master switch for the venue-owner subscription UI (the navbar status badge and
// the shortcut in the profile menu). Off while the billing flow is verified in
// prod, so existing owners don't stumble onto it before it's ready. The
// subscription page itself stays reachable by direct URL for testing.
export const SUBSCRIPTION_UI_ENABLED: boolean = false;
